/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  SupportedAiModelResponse,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    SupportedAiModelResponseFromJSON,
    SupportedAiModelResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class AiModelsApi extends runtime.BaseAPI {

    /**
     */
    async aiModelsGetSupportedChatModelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportedAiModelResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/ai-models/supportedChatModel`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportedAiModelResponseFromJSON(jsonValue));
    }

    /**
     */
    async aiModelsGetSupportedChatModel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportedAiModelResponse> {
        const response = await this.aiModelsGetSupportedChatModelRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async aiModelsGetSupportedImageModelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportedAiModelResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/ai-models/supportedImageModels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportedAiModelResponseFromJSON));
    }

    /**
     */
    async aiModelsGetSupportedImageModels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportedAiModelResponse>> {
        const response = await this.aiModelsGetSupportedImageModelsRaw(initOverrides);
        return await response.value();
    }

}
